module.exports = __webpack_public_path__ + "media/images/lb/474-4945444bb20c7a5b8871c7ee8a684f05.svg";